import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import PcSearch from "../search/pcSearch"
import NavBar from "./navBar"
import LinkCard from "../profile/linkCard"
import { isAuthenticated, signout } from "../../api/auth/helper"
import { API } from "../../api"
import axios from "axios"

function NavProfileCard(props) {
  const [loged, setLoged] = useState(false)

  const afterLogout = () => setLoged(true)

  const handleLogout = () => {
    return signout(afterLogout)
  }

  const { data } = isAuthenticated()

  return (
    <div className="dropdown">
      <div className="profile-card dropbtn">
        <div className="profile-image">
          <img
            src="https://img.freepik.com/free-vector/fresh-vegetable-funny-character-vector-illustration-design_24877-18338.jpg?size=338&ext=jpg"
            alt="profile-image"
          />
        </div>
        <div className="profile-details">
          <h3>{props.name}</h3>
          <h3>{props.number}</h3>
        </div>
      </div>
      <div class="dropdown-content">
        <section className="order-card-box w-100">
          <LinkCard
            link={"/my-orders/all"}
            title={"My Orders"}
            icon={<ion-icon name="fast-food"></ion-icon>}
          />
        </section>
        <section className="my-profile-card-box w-100">
          <LinkCard
            link={"/my-address"}
            title={"My Address"}
            icon={<ion-icon name="location"></ion-icon>}
          />
        </section>
        <section className="promo-code-card-box w-100">
          <LinkCard
            link={"/coupons-and-offers"}
            title={"Coupons & Offers"}
            icon={<ion-icon name="ticket"></ion-icon>}
          />
        </section>
        <section className="help-card-box w-100">
          <LinkCard
            link={"/about-us/support"}
            title={"Help"}
            icon={<ion-icon name="help-circle"></ion-icon>}
          />
        </section>
        <section className="wa-card-box w-100">
          {data ? (
            <div className="logout-btn" onClick={handleLogout}>
              <h2>Log-Out</h2>
              <ion-icon name="log-out"></ion-icon>
            </div>
          ) : (
            <Link to="/auth/intro">
              <div className="logout-btn">
                <ion-icon name="log-out"></ion-icon>
                <h2>Log-in</h2>
              </div>
            </Link>
          )}
        </section>
      </div>
    </div>
  )
}

export default function PcNav() {
  const { data } = isAuthenticated()
  const [cart, setCart] = useState(0);

  useEffect(() => {
    if (isAuthenticated()) {
      axios({
        method: "post",
        url: `${API}cart/getItems`,
        data: {
          user_id: data.user.number,
        },
      }).then((res) => {
        setCart(res.data.data.length);
      });
    }else {
      const cartArr = JSON.parse(localStorage.getItem("cart"));
      if (cartArr) {
        setCart(cartArr.length);
      }
    }
  }, []);
  return (
    <nav className="pc-nav">
      <div className="nav-menu-logo">
        <NavBar />
      </div>
      <div className="search-box">
        <PcSearch />
      </div>
      <div className="nav-link-list">
        <ul>
          <li>
            <Link to="/shop-on-whatsapp" className="link">
              <button className="nav-btn">Shop on WhatsApp</button>
            </Link>
          </li>
          <li>
            {isAuthenticated() ? (
              <NavProfileCard name={data.user.name} number={data.user.number} />
            ) : (
              <Link to="/auth/login" className="link">
                <button className="nav-btn">Login</button>
              </Link>
            )}
          </li>
          <li>
            <Link to="/my-basket" className="link d-flex">
              <div className="nav-add-to-cart-btn">
                <ion-icon name="basket"></ion-icon>
              </div>
              <span className="cart-item">{cart}</span>
            </Link>
          </li>
        </ul>
      </div>
      {/* <NavProfileCard name={"Shubham Raj"} number={"8709052626"} /> */}
    </nav>
  )
}
